module.exports = __webpack_public_path__ + "static/media/qiXishareBg.6db9bfd6.png";